class AccessHubVerificationController
  issues = ['unreadable', 'not issued', 'wrong id']

  panzoomInstance = null
  panzoomInstance2 = null

  # !! requires panzoom js lib
  @makeImageZoomable: (image) ->
    return if panzoomInstance

    photoContainerWidth = $('.photo-container')[0].offsetWidth
    photoContainerHeight = $('.photo-container')[0].offsetHeight
    pictureWidth = $('.panzoom-picture')[0].offsetWidth
    pictureHeight = $('.panzoom-picture')[0].offsetHeight
    initialZoomX = photoContainerWidth / pictureWidth
    initialZoomY = photoContainerHeight / pictureHeight
    initialZoom = if (initialZoomX > initialZoomY) then initialZoomX else initialZoomY

    panzoomInstance = panzoom(image, {
      smoothScroll: false,
      maxZoom: 10,
      minZoom: 1,
      zoomDoubleClickSpeed: 1,
      contain: true
    })
    panzoomInstance.zoomTo(pictureWidth / 2, pictureHeight / 2, initialZoom)

  @zoomIn: ->
    panzoomInstance.smoothZoom(195, 130, 1.25)

  @zoomOut: ->
    panzoomInstance.smoothZoom(195, 130, 0.8)

  @makeImageZoomable2: (image) ->
    return if panzoomInstance2

    photoContainerWidth = $('.photo-container')[1].offsetWidth
    photoContainerHeight = $('.photo-container')[1].offsetHeight
    pictureWidth = $('.panzoom-picture')[1].offsetWidth
    pictureHeight = $('.panzoom-picture')[1].offsetHeight
    initialZoomX = photoContainerWidth / pictureWidth
    initialZoomY = photoContainerHeight / pictureHeight
    initialZoom = if (initialZoomX > initialZoomY) then initialZoomX else initialZoomY

    panzoomInstance2 = panzoom(image, {
      smoothScroll: false,
      maxZoom: 10,
      minZoom: 1,
      zoomDoubleClickSpeed: 1,
      contain: true
    })
    panzoomInstance.zoomTo(pictureWidth / 2, pictureHeight / 2, initialZoom)

  @zoomIn2: ->
    panzoomInstance2.smoothZoom(195, 130, 1.25)

  @zoomOut2: ->
    panzoomInstance2.smoothZoom(195, 130, 0.8)


  @cancelRetakePhoto: (reason) ->
    switch reason
      when 'unclear face'
        accessHubVerificationChannel.cancelNewUserPhotoRequest()
      else
        accessHubVerificationChannel.cancelNewIdPhotoRequest()
    @goBack()

  @closeAllModalViews: ->
    for view in $('.modal')
      view.style.display = 'none'

  @enableAcceptIdButton: ->
    id_photo_id = $('#id_photo_id')[0].value
    id_readable = $('#id_readable_yes')[0].checked
    government_issued = $('#government_issued_yes')[0].checked
    user_matches_id = $('#user_matches_id_yes')[0].checked
    submitButton = $('#submit_button')[0]
    if id_photo_id && id_readable && government_issued && user_matches_id
      submitButton.disabled = false
    else
      submitButton.disabled = true

  @enableAcceptUserButton: ->
    user_photo_id = $('#user_photo_id')[0].value
    if user_photo_id && $('#clear_yes')[0].checked
      $('#submit_button')[0].disabled = false
    else
      $('#submit_button')[0].disabled = true

  @enablePersonMatchesIdButton: ->
    id_photo_id = $('#id_photo_id')[0].value
    user_photo_id = $('#user_photo_id')[0].value
    person_matches_id = $('#person_matches_id_yes')[0].checked
    if id_photo_id && user_photo_id && person_matches_id
      $('#submit_button')[0].disabled = false
    else
      $('#submit_button')[0].disabled = true

  @escalate: ->
    $('#submit_button')[0].disabled = true
    accessHubVerificationChannel_channel.escalate()

  @getModalViewFor: (issue) ->
    return switch issue
      when 'unreadable' then $('#retake_unreadable_modal')[0]
      when 'not issued' then $('#retake_not_issued_modal')[0]
      when 'unclear face' then $('#retake_unclear_face_modal')[0]
      when 'wrong id' then $('#retake_wrong_id_modal')[0]
      else null

  @getRadioButtonNoFor: (issue) ->
    switch issue
      when 'unreadable' then $('#id_readable_no')[0]
      when 'not issued' then $('#government_issued_no')[0]
      when 'wrong id' then $('#user_matches_id_no')[0]

  @goBack: ->
    @closeAllModalViews()
    @uncheckAllNoRadioButtons()

  @retakeIdPhoto: (issue) ->
    $('#submit_button')[0].disabled = true
    accessHubVerificationChannel.requestNewIdPhoto()
    @showModalViewFor(issue)

  @retakeUserPhoto: ->
    $('#submit_button')[0].disabled = true
    accessHubVerificationChannel.requestNewUserPhoto()
    @showModalViewFor('unclear face')

  @showModalViewFor: (issue) ->
    @closeAllModalViews()
    view = @getModalViewFor(issue)
    if view
      view.style.display = 'block'

  @submitTo: (action) ->
    form = $('#form')[0]
    form.action = action
    form.submit()

  @userNotMatchId: ->
    $('#submit_button')[0].disabled = true
    @showModalViewFor('wrong id')

  @uncheckAllNoRadioButtons: ->
    for view in $('.radio-button-no')
      view.checked = false

module.exports = AccessHubVerificationController
